import { DataBean } from "../DataBean";

export class PdfLibraryFactoryitems extends DataBean {
    
    

    public async getPdfLibraryFactoryItemCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getPdfLibraryFactoryItemCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

}